import {
  HEX_253548,
  HEX_292D38,
  HEX_3D526B,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_66AAFF,
  HEX_CED7E2,
  HEX_FCFDFE,
} from '@tanium/colors';
import { defineColor, Foreground1, Text2 } from '@tanium/react-theme-definition';

export const ButtonBorder = defineColor([HEX_CED7E2, HEX_253548]);
export const ButtonFill = defineColor([HEX_FCFDFE, HEX_3D526B]);
export const ButtonText = Text2;

export const ButtonSelectedBorder = defineColor([HEX_CED7E2, HEX_253548]);
export const ButtonSelectedFill = defineColor([HEX_3E4B68, HEX_477FBA]);
export const ButtonSelectedText = Foreground1;

export const ButtonHoverFill = defineColor([HEX_292D38, HEX_66AAFF]);
export const ButtonHoverText = Foreground1;
